export const name = "CURRENT_DATE";
export const summary = `Returns the current date as a \`DATE\` value.`;
export const reference = `
## CURRENT_DATE

Returns the current date as a \`DATE\` value.

\`\`\`
CURRENT_DATE()
\`\`\`

### 

\`\`\`
CURRENT_DATE(time_zone_expression)
\`\`\`



\`\`\`
CURRENT_DATE
\`\`\`


### Description

Returns the current date as a \`DATE\` object. Parentheses are optional when called with no arguments.

This function supports the following arguments:

- \`time_zone_expression\`: A \`STRING\` expression that represents a time zone. If no time zone is specified, the default time zone, UTC, is used. If this expression is used and it evaluates to \`NULL\`, this function returns \`NULL\`.

The current date value is set at the start of the query statement that contains this function. All invocations of \`CURRENT_DATE()\` within a query statement yield the same value.


### Return Data Type

\`DATE\`


### Examples

The following query produces the current date in the default time zone:



\`\`\`
SELECT CURRENT_DATE() AS the_date;

/*--------------*
 | the_date |
 +--------------+
 | 2016-12-25 |
 *--------------*/
\`\`\`

The following queries produce the current date in a specified time zone:



\`\`\`
SELECT CURRENT_DATE('America/Los_Angeles') AS the_date;

/*--------------*
 | the_date |
 +--------------+
 | 2016-12-25 |
 *--------------*/
\`\`\`



\`\`\`
SELECT CURRENT_DATE('-08') AS the_date;

/*--------------*
 | the_date |
 +--------------+
 | 2016-12-25 |
 *--------------*/
\`\`\`

The following query produces the current date in the default time zone. Parentheses aren't needed if the function has no arguments.



\`\`\`
SELECT CURRENT_DATE AS the_date;

/*--------------*
 | the_date |
 +--------------+
 | 2016-12-25 |
 *--------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
`;
